import { render, staticRenderFns } from "./AdministrationLayout.vue?vue&type=template&id=32e2bf94&scoped=true&lang=html&"
import script from "./AdministrationLayout.vue?vue&type=script&lang=js&"
export * from "./AdministrationLayout.vue?vue&type=script&lang=js&"
import style0 from "./AdministrationLayout.vue?vue&type=style&index=0&id=32e2bf94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e2bf94",
  null
  
)

export default component.exports